export default __webpack_public_path__ + "static/media/stjosephvictoria.7f3aea12.jpg";